import {createContext, useContext, useEffect, useReducer} from "react";
import {initialState, reducer, setQuery, setTotal, setWishList, setWishListLoading} from "./reducer";
import {useDelCollect, useQryCollectPage} from "../../../api/prodItemCollect";
import {mediaMatch} from "../../../utils";
import {useTranslation} from "react-i18next";
import useNotice from "../../../hooks/useNotice";

const Context = createContext(initialState);

function WishListController() {
  const { state, dispatch } = useWishListContext();
  const { loading, getList } = useQryCollectPage();
  const isMdmax = mediaMatch.isMdmax;
  const { delWishHandle } = useDelCollect();
  const { t } = useTranslation();
  const notice = useNotice();
  
  const getWishList = async (query) => {
    let q = {
      ...state.query,
      ...query,
    };
    
    let { data } = await getList(q);
    if (data) {
      dispatch(setQuery(q));
      dispatch(setWishList(data.records));
      dispatch(setTotal(Number(data.total)));
    }
  };
  
  /**
   * 跳转到 商品详情
   * @param id
   */
  const gotoProductDetail = (id) => {
    if (isMdmax) {
      navigateTo(`/goodsDetail?goodsId=${id}`);
    } else {
      let dir = window.location.pathname.endsWith('/') ? '' : '/';
      window.open(`${window.location.origin}${window.location.pathname}${dir}#/goodsDetail?goodsId=${id}`);
    }
  };
  
  const delWish = async (sourceId) => {
    let { data } = await delWishHandle({ sourceId });
    
    if (data) {
      notice.success('取消收藏');
      getWishList({ page: 1 });
    }
  };
  
  
  useEffect(() => {
    dispatch(setWishListLoading(loading));
  }, [loading]);
  
  return {
    loading,
    getWishList,
    delWish,
    gotoProductDetail
  };
}

function useWishListContext() {
  const { state, dispatch } = useContext(Context);
  
  return {
    state,
    dispatch,
  };
}

export {useWishListContext, WishListController};

export default function WishListContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  
  return (
    <Context.Provider
      value={{ state, dispatch }}
      reducer={reducer}>
      {children}
    </Context.Provider>
  );
}
